/* RESPONSIBLE TEAM: team-automation-foundations */
import AutomationFinAIAgentProcedureSidePanelsRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/procedures/procedure/sidepanels';

export default AutomationFinAIAgentProcedureSidePanelsRoute;
